'use client';
import { factory, useWindowSize, Box, Typography } from '@kohler-dsm-library/kohler-core';
import { ArrowUpIcon, ArrowDownIcon } from '@kohler-dsm-library/kohler-icons';
import clsx from 'clsx';
import React, { useState } from 'react';
import classes from './RegionItem.module.css.mjs';

const RegionItem = factory((props, ref) => {
  const { name, languages, isCurrentCountry, setSelectedCountry, href, className, mod, ...rest } = props;
  const [selectedRegionName, setSelectedRegionName] = useState(false);
  const { width } = useWindowSize();
  const isSmallSize = width < 1024;
  return /* @__PURE__ */ React.createElement(Box, { className: clsx(classes.regionItem, className), mod }, /* @__PURE__ */ React.createElement(
    Typography,
    {
      ref,
      component: languages ? isSmallSize ? "button" : "div" : "a",
      size: isSmallSize ? "navigation-overlay-title" : "navigation-overlay-item-m-regular",
      className: classes.regionItemCountry,
      textColor: isCurrentCountry && !isSmallSize ? "var(--content-action-inactive)" : "var(--content-action-default)",
      href,
      ...languages ? {
        onClick: () => {
          setSelectedCountry?.(name);
          setSelectedRegionName(!selectedRegionName);
        }
      } : { href },
      ...rest
    },
    name,
    " ",
    languages && isSmallSize ? selectedRegionName ? /* @__PURE__ */ React.createElement(ArrowUpIcon, { size: "small" }) : /* @__PURE__ */ React.createElement(ArrowDownIcon, { size: "small" }) : void 0
  ), (selectedRegionName || !isSmallSize) && /* @__PURE__ */ React.createElement("ul", { className: classes.languageMenuContentLanguageList }, languages?.map((language, index) => /* @__PURE__ */ React.createElement(
    "li",
    {
      key: language.text,
      className: clsx(
        classes.regionItemLanguage,
        !isSmallSize && index !== languages?.length - 1 && classes.regionItemLanguageDivider,
        isCurrentCountry && classes.regionItemLanguageDividerInactive
      )
    },
    /* @__PURE__ */ React.createElement(
      Typography,
      {
        className: clsx(
          classes.languageMenuContentListLanguageItemLink,
          isCurrentCountry && classes.languageMenuContentListLanguageItemLinkInactive
        ),
        component: language.href ? "a" : "span",
        size: isSmallSize ? "navigation-overlay-title" : "navigation-overlay-item-m-bold",
        ...language
      },
      language.text
    )
  ))));
});

export { RegionItem };
